/* VERKLINE global quick-add.
   Binds delegated click handler so ANY button of class
   .verkline-product-card__add-btn[data-variant-id] performs an
   AJAX /cart/add.js call with adding/added/error visual feedback.

   Used by: homepage (products-verkline, products-slider-verkline),
   collection pages (sections/main-collection.liquid) and brand
   collection pages (snippets/verkline-brand-view.liquid).
*/
(function () {
  'use strict';

  function setButtonLoading(btn, textAdding) {
    btn.classList.add('adding');
    btn.dataset.originalHtml = btn.innerHTML;
    btn.innerHTML =
      '<svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" class="spin">' +
      '<circle cx="12" cy="12" r="10"/><path d="M12 6v6l4 2"/></svg> ' + textAdding;
  }

  function setButtonAdded(btn, textAdded) {
    btn.classList.remove('adding');
    btn.classList.add('added');
    btn.innerHTML =
      '<svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2">' +
      '<path d="M20 6L9 17l-5-5"/></svg> ' + textAdded;
  }

  function setButtonError(btn, textError) {
    btn.classList.remove('adding');
    btn.innerHTML = textError;
  }

  function restoreButton(btn) {
    btn.classList.remove('added');
    if (btn.dataset.originalHtml) {
      btn.innerHTML = btn.dataset.originalHtml;
      delete btn.dataset.originalHtml;
    }
  }

  function bumpCartCount() {
    var cartCount = document.querySelector('.verkline-header__cart-count');
    if (!cartCount) return;
    var currentCount = parseInt(cartCount.textContent, 10) || 0;
    cartCount.textContent = currentCount + 1;
    cartCount.style.display = 'flex';
  }

  document.addEventListener('click', async function (e) {
    var btn = e.target.closest('.verkline-product-card__add-btn[data-variant-id]');
    if (!btn) return;
    // Options link (select-options) never has data-variant-id, so this is safe.
    e.preventDefault();
    e.stopPropagation();

    var variantId  = btn.dataset.variantId;
    var textAdding = btn.dataset.textAdding || 'Adding...';
    var textAdded  = btn.dataset.textAdded  || 'Added!';
    var textError  = btn.dataset.textError  || 'Error!';

    setButtonLoading(btn, textAdding);

    try {
      var response = await fetch('/cart/add.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ id: variantId, quantity: 1 })
      });
      if (!response.ok) throw new Error('add_to_cart_failed');
      setButtonAdded(btn, textAdded);
      bumpCartCount();
      setTimeout(function () { restoreButton(btn); }, 2000);

      // 2026-04-26: Show global toast notification (consistency with product page)
      if (window.cartDrawer && typeof window.cartDrawer.showAddedToast === 'function') {
        var productTitle = btn.dataset.productTitle || '';
        window.cartDrawer.showAddedToast(productTitle);
      }
    } catch (err) {
      setButtonError(btn, textError);
      setTimeout(function () { restoreButton(btn); }, 2000);

      if (window.cartDrawer && typeof window.cartDrawer.showAddedToast === 'function') {
        window.cartDrawer.showAddedToast('', true);
      }
    }
  });
})();
